
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 12","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.809 2.08L10.859.184A.648.648 0 0010.4 0H2.6a.665.665 0 00-.46.185L.191 2.08A.628.628 0 000 2.526v8.21C0 11.434.583 12 1.3 12h10.4c.717 0 1.3-.566 1.3-1.263v-8.21a.612.612 0 00-.191-.448zm-9.94-.817h7.262l.65.632H2.219l.65-.632zM6.5 10.105L3.25 6.947H5.2V5.053h2.6v1.894h1.95L6.5 10.105z"}})])
          )
        }
      }
    